import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

// routes
import MainRoutes from './MainRoutes';
import Snackbar from '../ui-component/extended/Snackbar';

// project imports
import config from './../config';

//-----------------------|| ROUTING RENDER ||-----------------------//

const Routes = () => {
    return (
        <>
            <Switch>
                <Redirect exact from="/" to={config.defaultPath} />
                <Route path="*" component={MainRoutes} />
            </Switch>
            <Snackbar />
        </>
    );
};

export default Routes;
